const groupPrefix = 'subpages-content'

export const apiSubpagesContent = {
	fetchSubpages: async () => {
		const response = await apiCommon<string[]>(`${groupPrefix}`, {
			method: 'GET',
		})
		if (!response) return { data: [] }

		return { data: response }
	},

	fetchSubpageSections: async (subpage: string) => {
		const { data } = await apiCommon<Partial<ICMSLocationContent>[]>(`${groupPrefix}/page/${subpage}`, {
			method: 'GET',
			skipSSRPayload: true,
		})
		if (!data) return { data: [] }
		const response = data.map((product) => {
			return CMSLocationContentFromJSON(product)
		})
		return { data: response }
	},

	updateSubpageSections: async (locationData: Partial<ICMSLocationContentModel>, subpagesContentID: number) => {
		const { data } = await apiCommon<Partial<ICMSLocationContent>>(`${groupPrefix}/${subpagesContentID}`, {
			method: 'PUT',
			body: CMSLocationContentToJSON(locationData),
		})
		return CMSLocationContentFromJSON(data)
	},
}
